// Generated by purs version 0.13.8
"use strict";
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Initial = function (initial) {
    this.initial = initial;
};
var initialUnit = new Initial(Data_Monoid.mempty(Data_Monoid.monoidUnit));
var initialString = new Initial(Data_Monoid.mempty(Data_Monoid.monoidString));
var initialSet = function (dictOrd) {
    return new Initial(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd)));
};
var initialRecord = function (dictRowToList) {
    return function (dictMonoidRecord) {
        return new Initial(Data_Monoid.mempty(Data_Monoid.monoidRecord()(dictMonoidRecord)));
    };
};
var initialOrdering = new Initial(Data_Monoid.mempty(Data_Monoid.monoidOrdering));
var initialNumber = new Initial(0.0);
var initialMaybe = new Initial(Data_Maybe.Nothing.value);
var initialMap = function (dictOrd) {
    return new Initial(Data_Monoid.mempty(Data_Map_Internal.monoidMap(dictOrd)));
};
var initialList = new Initial(Data_Monoid.mempty(Data_List_Types.monoidList));
var initialInt = new Initial(0);
var initialFn = function (dictMonoid) {
    return new Initial(Data_Monoid.mempty(Data_Monoid.monoidFn(dictMonoid)));
};
var initialBoolean = new Initial(false);
var initialArray = new Initial(Data_Monoid.mempty(Data_Monoid.monoidArray));
var initial = function (dict) {
    return dict.initial;
};
var initialTuple = function (dictInitial) {
    return function (dictInitial1) {
        return new Initial(new Data_Tuple.Tuple(initial(dictInitial), initial(dictInitial1)));
    };
};
module.exports = {
    initial: initial,
    Initial: Initial,
    initialUnit: initialUnit,
    initialBoolean: initialBoolean,
    initialInt: initialInt,
    initialNumber: initialNumber,
    initialString: initialString,
    initialOrdering: initialOrdering,
    initialMaybe: initialMaybe,
    initialArray: initialArray,
    initialList: initialList,
    initialMap: initialMap,
    initialSet: initialSet,
    initialFn: initialFn,
    initialTuple: initialTuple,
    initialRecord: initialRecord
};
